import http from '@/services/rest/rest.service';
import {
    ISortBody,
    ISiteTypeListModel,
    ISiteTypeDetailModel
} from '@/entities';

export default {
    list(siteId: number, sortBody: ISortBody): Promise<ISiteTypeListModel[]> {
        return http.get(`types/${siteId}/by-site`, sortBody);
    },
    get(id: number): Promise<ISiteTypeDetailModel> {
        return http.get(`types/${id}`);
    },
    update(id: number, body: ISiteTypeDetailModel): Promise<number> {
        return http.post(`types/${id}`, body);
    },
    create(body: ISiteTypeDetailModel): Promise<number> {
        return http.put(`types`, body);
    }
};
